import React, { useState, useEffect } from 'react';
import NewsHeroForm from './NewsHeroForm';
import NewsPressForm from './NewsPressForm';
import NewsArticlesForm from './NewsArticlesForm';
import { 
  Newspaper, 
  Megaphone, 
  BookOpen 
} from 'lucide-react';
import './FormsUnified.css';

const TABS = [
  { id: 'hero', title: 'Hero Section', icon: Newspaper, component: NewsHeroForm },
  { id: 'press', title: 'Press Releases', icon: Megaphone, component: NewsPressForm },
  { id: 'articles', title: 'Blog & Articles', icon: BookOpen, component: NewsArticlesForm }
];

export default function NewsUpdatesForm({ apiBase, activeTab }) {
  const getInitialTab = () => {
    if (activeTab === 'cms-news-articles' || activeTab === 'news-articles' || activeTab === 'cms-news-list') return 'articles';
    if (activeTab === 'cms-news-press' || activeTab === 'news-press' || activeTab === 'cms-news-events') return 'press';
    return 'hero';
  };

  const [currentTab, setCurrentTab] = useState(getInitialTab);

  useEffect(() => {
    setCurrentTab(getInitialTab());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const activeTabConfig = TABS.find(t => t.id === currentTab) || TABS[0];
  const ActiveComponent = activeTabConfig.component;

  return (
    <div className="unified-master-container">
      {/* Tab Navigation Pill Bar */}
      <div className="unified-tab-bar">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = tab.id === currentTab;

          return (
            <button
              key={tab.id}
              type="button"
              className={`tab-pill-btn ${isActive ? 'active' : ''}`}
              onClick={() => setCurrentTab(tab.id)}
            >
              <Icon className="w-4 h-4 mr-2" size={16} />
              <span>{tab.title}</span>
            </button>
          );
        })}
      </div>

      {/* Render Active Section Sub-Form */}
      <div className="unified-tab-content">
        <ActiveComponent apiBase={apiBase} />
      </div>
    </div>
  );
}
